import * as activitiApprovalFacadeImpl from "./activitiApprovalFacadeImpl";
import * as asMaterialRejectBill from "./asMaterialRejectBill";
import * as asMaterialRejectBillFacadeImpl from "./asMaterialRejectBillFacadeImpl";
import * as asMaterialRejectBillItem from "./asMaterialRejectBillItem";
import * as asRefundOrder from "./asRefundOrder";
import * as asRefundOrderFacadeImpl from "./asRefundOrderFacadeImpl";
import * as asRefundOrderItem from "./asRefundOrderItem";
import * as backdoor from "./backdoor";
import * as common from "./common";
import * as mskuFacadeImpl from "./mskuFacadeImpl";
import * as mskuMap from "./mskuMap";
import * as omsFlowPackageChangeFacadeImpl from "./omsFlowPackageChangeFacadeImpl";
import * as omsFlowSystemOrderItemFacadeImpl from "./omsFlowSystemOrderItemFacadeImpl";
import * as returnReasonEnum from "./returnReasonEnum";
import * as systemOrder from "./systemOrder";
import * as systemOrderContract from "./systemOrderContract";
import * as systemOrderCorrelation from "./systemOrderCorrelation";
import * as systemOrderFacadeImpl from "./systemOrderFacadeImpl";
import * as systemOrderItem from "./systemOrderItem";
import * as systemOrderPackage from "./systemOrderPackage";
import * as systemOrderPackageDeliveryInformation from "./systemOrderPackageDeliveryInformation";
import * as systemOrderPackageItem from "./systemOrderPackageItem";
import * as systemOrderPackageItemFacadeImpl from "./systemOrderPackageItemFacadeImpl";
import * as systemOrderRelevance from "./systemOrderRelevance";
import * as systemOrderRemark from "./systemOrderRemark";
import * as systemOrderSynFacadeImpl from "./systemOrderSynFacadeImpl";

export const omsFlow = {
  activitiApprovalFacadeImpl,
  asMaterialRejectBill,
  asMaterialRejectBillFacadeImpl,
  asMaterialRejectBillItem,
  asRefundOrder,
  asRefundOrderFacadeImpl,
  asRefundOrderItem,
  backdoor,
  common,
  mskuFacadeImpl,
  mskuMap,
  omsFlowPackageChangeFacadeImpl,
  omsFlowSystemOrderItemFacadeImpl,
  returnReasonEnum,
  systemOrder,
  systemOrderContract,
  systemOrderCorrelation,
  systemOrderFacadeImpl,
  systemOrderItem,
  systemOrderPackage,
  systemOrderPackageDeliveryInformation,
  systemOrderPackageItem,
  systemOrderPackageItemFacadeImpl,
  systemOrderRelevance,
  systemOrderRemark,
  systemOrderSynFacadeImpl,
};
